import { useLayoutEffect, useRef } from 'react';
import { isMobileApp } from 'common-react';

const globalScrollLockCount = { current: 0 };

const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

const setScrollbarWidthVariable = (scrollbarWidth: number) => {
  document.documentElement.style.setProperty('--scrollbar-width', `${Math.max(scrollbarWidth, 0)}px`);
};

const useBodyScrollLock = (shouldAllowScroll = false) => {
  const isLocked = useRef(false);
  const mobileApp = isMobileApp();

  useLayoutEffect(() => {
    if (!shouldAllowScroll && !isLocked.current) {
      globalScrollLockCount.current++;
      isLocked.current = true;

      if (!mobileApp) {
        const scrollbarWidth = getScrollbarWidth();
        setScrollbarWidthVariable(scrollbarWidth);
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }
      } else {
        setScrollbarWidthVariable(0);
      }

      document.body.style.overflow = 'hidden';
    }

    return () => {
      if (!shouldAllowScroll && isLocked.current) {
        globalScrollLockCount.current--;
        isLocked.current = false;

        if (globalScrollLockCount.current === 0) {
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('padding-right');
          setScrollbarWidthVariable(0);
          // Fallback — check count again in case a new lock was acquired before setTimeout fires
          setTimeout(() => {
            if (globalScrollLockCount.current === 0) {
              document.body.style.removeProperty('overflow');
              document.body.style.removeProperty('padding-right');
              setScrollbarWidthVariable(0);
            }
          }, 0);
        }
      }
    };
  }, [mobileApp, shouldAllowScroll]);
};

export { useBodyScrollLock };